import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import mixin from './mixins'

createApp(App).use(router).mount('#app')